import { render, staticRenderFns } from "./merchantLanding.vue?vue&type=template&id=39f0e47d&scoped=true"
import script from "./merchantLanding.vue?vue&type=script&lang=js"
export * from "./merchantLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0e47d",
  null
  
)

export default component.exports